import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ThemeModeService } from '@ui-kit';

@Component({
  imports: [RouterModule],
  selector: 'two-x-landing-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private themeModeService = inject(ThemeModeService);

  ngOnInit() {
    this.themeModeService.init();
  }
}
